import styled from 'styled-components';
import { CustomThemeToken } from '@/theme';

interface AlertsBarContainerProps {
  theme: { token: CustomThemeToken };
}

export const AlertsBarContainer = styled.div<AlertsBarContainerProps>`
  .alerts-container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: ${({ theme: { token } }) => token.margin}px;
  }
`;
